module.exports = __webpack_public_path__ + "img/redoButtonOff.28ec775b.svg";